export type PlanInformationType = {
  key: number
  iconType: 'success' | 'star'
  name: string
  isPremium?: boolean
}

export const planInformation: PlanInformationType[] = [
  {
    key: 1,
    iconType: 'success',
    name: 'Instalación de dispositivos',
    isPremium: true,
  },
  {
    key: 2,
    iconType: 'success',
    name: 'Plan de datos para GPS',
    isPremium: true,
  },
  {
    key: 3,
    iconType: 'success',
    name: 'Bloquedo/desbloqueo de motor',
    isPremium: true,
  },
  {
    key: 5,
    iconType: 'success',
    name: 'Agendamiento de mantenciones',
    isPremium: false,
  },
  {
    key: 6,
    iconType: 'success',
    name: 'Asistencia en ruta 24/7',
    isPremium: false,
  },
  {
    key: 7,
    iconType: 'success',
    name: 'Recuperación de vehículo robado',
    isPremium: true,
  },
  {
    key: 8,
    iconType: 'success',
    name: 'Alertas del vehículo',
    isPremium: true,
  },
/*   {
    key: 9,
    iconType: 'star',
    name: 'Podrás activar la renovación automática',
    isPremium: true,
  }, */
]
